import { FC, useState } from "react";
import { Card, Modal, Spin } from "antd";
import AddSchedule from "./AddSchedule";
import { useIntl } from "react-intl";
import { workingHoursAndShiftResponse } from "../../../../types/teamMember";
import { getLocationDetailsAdmin } from "../../../../network/admin";
import { useQuery } from "@tanstack/react-query";
import { location } from "../../../../types/calendar";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

interface AddServiceFormProps {
  visible: boolean;
  onClose: () => void;
  team_member_id: number;
  location_id: number;
  selectedDate: any;
  config?: {
    isAdmin?: boolean;
    isEdit?: boolean;
    workingHourId?: number;
    workingHoursWithShifts?: workingHoursAndShiftResponse;
  };
}

const AddServiceForm: FC<AddServiceFormProps> = ({
  visible,
  onClose,
  team_member_id,
  location_id,
  selectedDate,
  config,
}) => {
  const { currentLang, activeLocation } = useSelector(
    (state: {
      user: { currentLang: "en" | "ar" };
      calendar: { activeLocation: location | null };
    }) => {
      return {
        currentLang: state?.user?.currentLang,
        activeLocation: state.calendar.activeLocation,
      };
    }
  );
  const intl = useIntl();
  const { data: locationDetails, isFetching } = useQuery(
    ["location", location_id],
    () => getLocationDetailsAdmin(location_id),
    {
      select: (res) => res.data,
      enabled: !!config?.isAdmin && !!location_id && !!config?.isEdit, //! on update from salon make it depend on locationId only and add function to fetch salon locationId if not (activeLocation)
    }
  );
  return (
    <Modal
      centered
      open={visible}
      onCancel={onClose}
      okButtonProps={{ disabled: true }}
      cancelButtonProps={{ disabled: true }}
      footer={[]}
      width={700}
    >
      {isFetching ? (
        <div className="flex h-screen items-center justify-center">
          <Spin size="large" />
        </div>
      ) : (
        <Card className="mx-12 my-7 border-0">
          <div className="text-color-primary text-2xl font-semibold leading-7 text-center">
            {intl.formatMessage({
              id: "workingShift",
              defaultMessage: "  دورة عمل",
            })}
          </div>

          <AddSchedule
            onClose={onClose}
            team_member_id={team_member_id}
            location_id={location_id}
            selectedDate={
              selectedDate || dayjs(new Date()).format("YYYY-MM-DD")
            }
            config={config}
            locationDetails={locationDetails || activeLocation}
          />
        </Card>
      )}
    </Modal>
  );
};

export default AddServiceForm;
